import { createContext, useContext, useEffect, useState } from 'react';

const MetaContext = createContext();

const readCookie = (name) => {
  const match = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
  );
  return match ? decodeURIComponent(match[1]) : '';
};

export const MetaProvider = ({ children }) => {

  /*
   * Meta "Click ID" (fbclid) and derived fbc / fbp identifiers
   * https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
   */

  // LOCAL STORAGE — persist fbclid across the signup wizard

  const KEY_CLICK_ID = 'meta_click_id';
  const KEY_FBC = 'meta_fbc';

  const [ fbclid, setFbclid ] = useState(() => {
    return localStorage.getItem(KEY_CLICK_ID) || '';
  });

  const [ fbc, setFbc ] = useState(() => {
    return localStorage.getItem(KEY_FBC) || '';
  });

  const [ fbp, setFbp ] = useState(() => {
    return readCookie('_fbp');
  });

  useEffect(() => {
    localStorage.setItem(KEY_CLICK_ID, fbclid || '');
  }, [fbclid]);

  useEffect(() => {
    localStorage.setItem(KEY_FBC, fbc || '');
  }, [fbc]);

  // URL PARAMETER — capture fbclid on landing and derive fbc

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const value = params.get('fbclid');
    if (value) {
      setFbclid(value);
      setFbc('fb.1.' + Date.now() + '.' + value);
    }
  }, []);

  // _fbp cookie — set by the Pixel base code; pick it up once available

  useEffect(() => {
    if (fbp) {
      return;
    }
    const id = setInterval(() => {
      const value = readCookie('_fbp');
      if (value) {
        setFbp(value);
        clearInterval(id);
      }
    }, 500);
    return () => clearInterval(id);
  }, [fbp]);

  /*
   * Final context
   */

  const context = {
    fbclid, setFbclid,
    fbc,
    fbp,
  };

  return (
    <MetaContext.Provider value={context}>
      {children}
    </MetaContext.Provider>
  );
};

export const useMetaContext = () => useContext(MetaContext);

export const metaPixel = {
  track: (eventName, eventProps, options) => {
    console.log(['meta', eventName, eventProps, options]);
    if (window.fbq && typeof window.fbq === 'function') {
      window.fbq('track', eventName, eventProps || {}, options || {});
    }
  },
};
